export interface HeadsetInputContextState {
    headset?: HIDDevice;
    reportValues: number[];
	headsetLoading: boolean;
}

export const initialState: HeadsetInputContextState = {
    reportValues: [],
	headsetLoading: false,
}

export type HeadsetInputReducerAction =
    {
        type: 'setHeadset',
        payload?: HIDDevice
    } | {
    type: 'newReport',
    payload: number,
} | {
	type: 'setHeadsetLoading',
	payload: boolean
}

export const headsetReducer = (state: HeadsetInputContextState, action: HeadsetInputReducerAction): HeadsetInputContextState => {

    switch (action.type) {
        case "setHeadset":
            return {
                ...state,
	            headsetLoading: false,
                headset: action.payload
            }
	    case "setHeadsetLoading":
			return {
				...state,
				headsetLoading: action.payload
			}
        case "newReport":
            return {
                ...state,
                reportValues: [...state.reportValues, action.payload]
            }
        default:
            return state
    }
}
